<template>
  <v-text-field
    v-show-fade="{ isFilter: isFilter }"
    :value="value"
    v-bind="$attrs"
    hide-details
    :clearable="clearable"
    autocomplete="off"
    outlined
    :class="[selectMixinClass]"
    @input="
      value => {
        $emit('input', value);
      }
    "
  />
</template>
<script>
import selectsMixin from "./selects_mixin";
export default {
  name: "AppGenericTextField",
  mixins: [selectsMixin]
};
</script>
